import { render, staticRenderFns } from "./LiveBrowsing.vue?vue&type=template&id=021ed827&scoped=true"
import script from "./LiveBrowsing.vue?vue&type=script&lang=js"
export * from "./LiveBrowsing.vue?vue&type=script&lang=js"
import style0 from "./LiveBrowsing.vue?vue&type=style&index=0&id=021ed827&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021ed827",
  null
  
)

export default component.exports